import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './services/auth.service';

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {

  }

  canActivate(): boolean {
    if (!this.authService.isAuthenticated())
      this.authService.login();

    return this.authService.isAuthenticated();
  }

  canLoad(): boolean {
    if (!this.authService.isAuthenticated())
      this.authService.login();

    return this.authService.isAuthenticated();
  }
}